import { combineReducers } from "@reduxjs/toolkit";
import deparmentTypeSlice from "./slices/deparmentTypeSlice";
import workPositionTypeSlice from "./slices/workPositionTypeSlice";
import workAreaSlice from "./slices/workAreaSlice";
import departmentSlice from "./slices/departmentSlice";
import workPositionSlice from "./slices/workPositionSlice";
import costCenterSlice from "./slices/costCenterSlice";
import positionSlice from "./slices/positionSlice";
import terminationCategorySlice from "./slices/terminationCategorySlice";
import terminationReasonSlice from "./slices/terminationReasonSlice";
import contractTypeSlice from "./slices/contractTypeSlice";
import documentTypeSlice from "./slices/documentTypeSlice";
import parentTypeSlice from "./slices/parentTypeSlice";
import infoEmployeeSlice from "./slices/infoEmployeeSlice";
import contributionTypeSlice from "./slices/contributionTypeSlice";
import contributionEmployeeSlice from "./slices/contributionEmployeeSlice";
import documentByEmployeeSlice from "./slices/documentByEmployeeSlice";
import accountTypeSlice from "./slices/accountTypeSlice";
import paymentMethodSlice from "./slices/paymentMethodSlice";
import accountByEmployeeSlice from "./slices/accountByEmployeeSlice";
import parentInfoSlice from "./slices/parentInfoSlice";

export default combineReducers({
  deparmentTypes: deparmentTypeSlice,
  workPositionTypes: workPositionTypeSlice,
  workAreas: workAreaSlice,
  departments: departmentSlice,
  workPositions: workPositionSlice,
  costCenters: costCenterSlice,
  positions: positionSlice,
  terminationCategories: terminationCategorySlice,
  terminationReasons: terminationReasonSlice,
  contractTypes: contractTypeSlice,
  documentTypes: documentTypeSlice,
  parentTypes: parentTypeSlice,
  infoEmployees: infoEmployeeSlice,
  contributionTypes: contributionTypeSlice,
  contributionEmployees: contributionEmployeeSlice,
  documentByEmployees: documentByEmployeeSlice,
  accountTypes: accountTypeSlice,
  paymentMethods: paymentMethodSlice,
  accountByEmployees: accountByEmployeeSlice,
  parentInfos: parentInfoSlice,
});
